import axios from 'axios';

import { AuthenticationClient } from '../authentication/client';
import { logger } from '../logging';

import { FILTERS_URL } from './utils';
import { CreateFilter, CreateFilterResponse } from './types';

export const createFilter = async (filter: CreateFilter): Promise<CreateFilterResponse> => {
  try {
    const token = await AuthenticationClient.getInstance().getAccessToken();

    const result = await axios.post(`/v2/filters`, filter, {
      baseURL: FILTERS_URL,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return result.data;
  } catch (e) {
    logger.error(e);
    throw e;
  }
};
